export enum CampaignStatus {
  ACTIVE = 'ACTIVE',
  PASSIVE = 'PASSIVE',
  PENDING = 'PENDING',
  DELETED = 'DELETED'
}
